var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#4D008C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3.5a.5.5 0 01.5.5v16a.5.5 0 01-1 0V4a.5.5 0 01.5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 12a.5.5 0 01-.5.5H4a.5.5 0 010-1h16a.5.5 0 01.5.5z"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgaWQ9InBsdXMiPgo8ZyBpZD0iVmVjdG9yIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMiAzLjVDMTIuMjc2MSAzLjUgMTIuNSAzLjcyMzg2IDEyLjUgNFYyMEMxMi41IDIwLjI3NjEgMTIuMjc2MSAyMC41IDEyIDIwLjVDMTEuNzIzOSAyMC41IDExLjUgMjAuMjc2MSAxMS41IDIwVjRDMTEuNSAzLjcyMzg2IDExLjcyMzkgMy41IDEyIDMuNVoiIGZpbGw9IiM0RDAwOEMiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMC41IDEyQzIwLjUgMTIuMjc2MSAyMC4yNzYxIDEyLjUgMjAgMTIuNUw0IDEyLjVDMy43MjM4NiAxMi41IDMuNSAxMi4yNzYxIDMuNSAxMkMzLjUgMTEuNzIzOSAzLjcyMzg2IDExLjUgNCAxMS41TDIwIDExLjVDMjAuMjc2MSAxMS41IDIwLjUgMTEuNzIzOSAyMC41IDEyWiIgZmlsbD0iIzREMDA4QyIvPgo8L2c+CjwvZz4KPC9zdmc+Cg==";
export { SvgPlus as ReactComponent };